import React from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = React.useState(false);

  React.useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

 

  if (!showConsent) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h4>Χρησιμοποιούμε Cookies</h4>
          <p>
            Αυτός ο ιστότοπος χρησιμοποιεί cookies για να βελτιώσει την εμπειρία σας, να αναλύσει την επισκεψιμότητα και να παρέχει εξατομικευμένο περιεχόμενο. Με το να συνεχίσετε να χρησιμοποιείτε τον ιστότοπό μας, συμφωνείτε με τη χρήση των cookies.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Αποδοχή Όλων
          </button>
        
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;